import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createDevTools } from 'redux-devtools';
// eslint-disable-next-line import/no-extraneous-dependencies
import LogMonitor from 'redux-devtools-log-monitor';
// eslint-disable-next-line import/no-extraneous-dependencies
import DockMonitor from 'redux-devtools-dock-monitor';

export default createDevTools(
  <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-w">
    <LogMonitor />
  </DockMonitor>,
);



// WEBPACK FOOTER //
// ./src/store/DevTools.js